import Repository from "../../services/repositories/repositoryFactory";
import { errorMessage, errorValidationMessage, tokenExpired } from "../../utils/alertMessages";

const blackList = Repository.service("blackList");

export default {
  namespaced: true,
  state: {
    allBlackList: null,
  },
  getters: {
    showAllBlackList(state) {
      return state.allBlackList;
    },
  },
  mutations: {
    setAllBlackList(state, newAllBlackList) {
      state.allBlackList = newAllBlackList;
    },
  },
  actions: {
    async getAllBlackList({ commit }, params) {
      try {
        const response = await blackList.getAllBlackList(params);
        commit("setAllBlackList", response.data);
        return response;
      } catch (error) {
        if (error.response.status === 401) {
          tokenExpired();
        } else if (error.response.status === 422) {
          errorValidationMessage(error.response.data.detail[0].msg);
        } else if (error.response.data.detail) {
          errorValidationMessage(error.response.data.detail);
        } else {
          errorMessage();
        }
        return error;
      }
    },
    async createBlackListItem(_, payload) {
      try {
        const response = await blackList.createBlackListItem(payload);
        return response;
      } catch (error) {
        if (error.response.status === 401) {
          tokenExpired();
        } else if (error.response.status === 422) {
          errorValidationMessage(error.response.data.detail[0].msg);
        } else if (error.response.data.detail) {
          errorValidationMessage(error.response.data.detail);
        } else {
          errorMessage();
        }
        return error;
      }
    },
    async updateBlackListItem(_, { id, body }) {
      try {
        const response = await blackList.updateBlackListItem(id, body);
        return response;
      } catch (error) {
        if (error.response.status === 401) {
          tokenExpired();
        } else if (error.response.status === 422) {
          errorValidationMessage(error.response.data.detail[0].msg);
        } else if (error.response.data.detail) {
          errorValidationMessage(error.response.data.detail);
        } else {
          errorMessage();
        }
        return error;
      }
    },
    async deleteBlackListItem(_, id) {
      try {
        const response = await blackList.deleteBlackListItem(id);
        return response;
      } catch (error) {
        if (error.response.status === 401) {
          tokenExpired();
        } else if (error.response.status === 422) {
          errorValidationMessage(error.response.data.detail[0].msg);
        } else if (error.response.data.detail) {
          errorValidationMessage(error.response.data.detail);
        } else {
          errorMessage();
        }
        return error;
      }
    },
  },
};
